<template>
  <div class="live-wrap" dir="rtl">

    <!-- ── Free preview spent: shared paywall ── -->
    <PreviewPaywall
      v-if="previewBlocked"
      :display-name="user_data && user_data.display_name ? user_data.display_name : ''"
      :bg-image="pic"
      :is-logged-in="!!get_me"
    />

    <!-- ── Watchable (subscriber, or preview still running) ── -->
    <div
      v-if="previewGateOpen"
      class="live-player"
      :class="is_user_active ? 'live-player--active' : 'live-player--inactive'"
      @mousemove="user_hover"
      @touchmove="user_hover"
    >

      <!-- Glass back button -->
      <button
        type="button"
        class="live-player__back tov_animate"
        aria-label="חזור אחורה"
        @click="$router.go(-1)"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>

      <!-- Title overlay -->
      <div class="live-player__title-bar" v-if="data && data.name">
        <span class="live-player__live-badge">שידור חי</span>
        <h1 class="live-player__title" v-text="data.name"></h1>
      </div>

      <!-- Video area -->
      <div
        id="video_wrapper"
        class="live-player__video-wrapper"
        @mouseover="show_controls = true"
        @mouseleave="show_controls = false"
      >
        <!-- Native video.js player (non-iframe stream) -->
        <video
          ref="videoPlayer"
          class="video-js"
          autoplay
          v-if="iframe_html === ''"
        ></video>

        <!-- Iframe embed -->
        <div
          class="live-player__iframe-wrap"
          v-html="iframe_html"
          v-else
        ></div>
      </div>

    </div>

  </div>
</template>

<script>
import videojs from 'video.js';
require('video.js/dist/video-js.min.css');
import PreviewPaywall from './ui/PreviewPaywall.vue';
import previewLimit from '../mixins/previewLimit';

export default {
  components: { PreviewPaywall },
  mixins: [previewLimit],

  data() {
    return {
      data: [],
      pic: '',
      iframe_html: '',
      promoted: [],
      categories: [],
      category: [],
      id: this.$route.params.id,

      player: null,
      loaded: false,
      is_user_active: false,
      is_user_active_timer: null,
      show_controls: false,

      videoOptions: {
        autoplay: true,
        controls: true,
        sources: [{ src: '', type: 'video/mp4' }],
      },
    };
  },

  updated() {
    window.dispatchEvent(new Event('resize'));
  },

  created() {
    this.$emit('show_loader');
    var self = this;

    this.api_call({
      url: 'live',
      data: { id: this.id },
      onComplete: function(data) {
        self.data = data.data.data.live;
        self.pic  = data.data.data.pic;
        self.$emit('loaded');

        self.restorePreviewState();

        if (self.data.link.includes('iframe')) {
          self.iframe_html = self.data.link;
          // Third-party embed: nothing to listen to, so time the preview on the
          // wall clock and let the template drop the embed when it runs out.
          self.startPreviewClock();
        } else {
          self.videoOptions.poster = self.pic;
          self.videoOptions.sources = [{
            src: self.data.link || '',
            type: (self.data.link.search('m3u8') !== -1 ? 'application/x-mpegURL' : 'video/mp4'),
          }];

          self.videoOptions.controlBar = {
            children: [
              'progressControl',
              'CurrentTimeDisplay',
              'TimeDivider',
              'DurationDisplay',
              'ProgressControl',
              'LiveDisplay',
              'RemainingTimeDisplay',
              'CustomControlSpacer',
              'PlaybackRateMenuButton',
              'ChaptersButton',
              'DescriptionsButton',
              'AudioTrackButton',
            ],
          };

          self.player = videojs(self.$refs.videoPlayer, self.videoOptions, function onPlayerReady() {
            self.player.on('timeupdate', function() {
              self.user_watch_time = self.currentTime;
              self.trackPreview(self.currentTime);
            });
            self.initPreviewGuard();
          });

          // LEFT GROUP
          self.player.controlBar.left_group = self.player.controlBar.addChild('Component');
          self.player.controlBar.left_group.addClass('left_group');
          self.player.controlBar.left_group.addChild('FullscreenToggle');
          if (!self.is_mobile()) self.player.controlBar.left_group.addChild('PictureInPictureToggle');
          self.player.controlBar.left_group.addChild('SubsCapsButton');
          if (!self.is_mobile()) self.player.controlBar.left_group.addChild('VolumePanel');
          self.player.controlBar.el().append(
            self.player.controlBar.left_group.el(),
            self.player.controlBar.el().firstChild.nextSibling
          );

          // CENTER GROUP
          self.player.controlBar.center_group = self.player.controlBar.addChild('Component');
          self.player.controlBar.center_group.addClass('center_group');
          self.player.controlBar.center_group.addChild('PlayToggle');
          self.player.controlBar.el().append(
            self.player.controlBar.center_group.el(),
            self.player.controlBar.el().firstChild.nextSibling
          );

          // RIGHT GROUP
          self.player.controlBar.right_group = self.player.controlBar.addChild('Component');
          self.player.controlBar.right_group.addClass('right_group');
          self.player.controlBar.el().append(
            self.player.controlBar.right_group.el(),
            self.player.controlBar.el().firstChild.nextSibling
          );
        }

        self.loaded = true;
        self.$emit('loaded');
      },
    });
  },

  computed: {
    is_user_can_watch() {
      if (!this.get_me) return false;
      return this.get_me.is_active == true;
    },

    previewKey() {
      return this.id ? 'live_' + this.id : 'live';
    },

    // Live playhead is elapsed broadcast time, not "how much have I watched".
    previewUsesPlayhead() {
      return false;
    },

    is_user_login() {
      if (!this.get_me) return false;
      return true;
    },

    currentTime: {
      get() {
        return this.player ? this.player.currentTime() : 0;
      },
      set(newValue) {
        if (this.player) this.player.currentTime(newValue);
      },
    },
  },

  methods: {
    user_hover() {
      this.is_user_active = true;
      window.clearTimeout(this.is_user_active_timer);
      this.is_user_active_timer = setTimeout(() => {
        this.is_user_active = false;
      }, 3000);
    },
  },

  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>

<style lang="scss" scoped>
/* ── Gate (subscription required) ── */
.live-gate {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-bg);
  font-family: var(--font-hebrew);
}

.live-gate__back {
  position: absolute;
  inset-block-start: 0;
  inset-inline-end: 0;
  width: 50px;
  height: 50px;
  min-width: 44px;
  min-height: 44px;
  background: var(--color-text);
  color: var(--color-bg);
  border: none;
  border-radius: var(--radius-sm);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity var(--duration-fast) var(--easing-default);
  z-index: 5;

  &:hover { opacity: 0.85; }

  &:focus-visible {
    outline: 2px solid var(--color-accent);
    outline-offset: 2px;
  }

  svg { transform: scaleX(1); }
}

.live-gate__inner {
  text-align: center;
  padding: var(--space-8);
}

.live-gate__banner {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-4);
  padding: var(--space-8) var(--space-12);
  background: rgba(225, 29, 42, 0.12);
  border: 1px solid rgba(225, 29, 42, 0.33);
  border-radius: var(--radius-md);
  color: var(--color-text);

  b {
    font-size: 22px;
    font-weight: 700;
    color: var(--color-accent);
  }

  p {
    margin: 0;
    font-size: 16px;
    color: var(--color-textMuted);
    line-height: 1.5;
  }

  div {
    font-size: 15px;
    color: var(--color-textMuted);
  }
}

.live-gate__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding-inline: var(--space-8);
  background: var(--color-accent);
  color: #ffffff;
  font-family: var(--font-hebrew);
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  min-width: 44px;
  transition: background var(--duration-fast) var(--easing-default);

  &:hover { background: var(--color-accentHover); }
  &:active { background: var(--color-accentPress); }

  &:focus-visible {
    outline: 2px solid var(--color-accent);
    outline-offset: 2px;
    box-shadow: var(--shadow-glow);
  }
}

/* ── Player layout ── */
.live-player {
  position: relative;
  width: 100%;
  height: 100vh;
  background: var(--color-bg);
  overflow: hidden;
  font-family: var(--font-hebrew);

  /* Fade controls in/out based on user activity */
  .live-player__back,
  .live-player__title-bar {
    transition: opacity var(--duration-slow) var(--easing-default);
  }

  &.live-player--inactive {
    .live-player__back,
    .live-player__title-bar {
      opacity: 0;
      pointer-events: none;
    }
  }

  &.live-player--active {
    .live-player__back,
    .live-player__title-bar {
      opacity: 1;
    }
  }
}

/* Glass back button */
.live-player__back {
  position: absolute;
  inset-block-start: var(--space-4);
  inset-inline-end: var(--space-4);
  z-index: 10;
  width: 44px;
  height: 44px;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  color: #ffffff;
  border: none;
  border-radius: var(--radius-sm);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity var(--duration-fast) var(--easing-default),
              background var(--duration-fast) var(--easing-default);

  &:hover { background: rgba(0, 0, 0, 0.8); }

  &:focus-visible {
    outline: 2px solid var(--color-accent);
    outline-offset: 2px;
  }

  /* In RTL the arrow already points in the correct "back" direction */
  svg { transform: scaleX(1); }
}

/* Title bar overlay */
.live-player__title-bar {
  position: absolute;
  inset-block-start: 0;
  inset-inline: 0;
  z-index: 9;
  padding: var(--space-6) var(--space-8);
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, transparent 100%);
  display: flex;
  align-items: center;
  gap: var(--space-3);
  pointer-events: none;
}

.live-player__live-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  background: var(--color-accent);
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.8px;
  border-radius: 2px;
  font-family: var(--font-sans);
  flex-shrink: 0;
}

.live-player__title {
  font-size: 20px;
  font-weight: 700;
  color: var(--color-text);
  margin: 0;
  letter-spacing: -0.3px;
  line-height: 1.2;
}

/* Video wrapper fills the entire viewport */
.live-player__video-wrapper {
  width: 100%;
  height: 100%;

  .video-js {
    width: 100% !important;
    height: 100% !important;
  }
}

/* Iframe embed — maintain 16:9 */
.live-player__iframe-wrap {
  aspect-ratio: 16 / 9;
  width: 100%;

  iframe {
    aspect-ratio: 16 / 9;
    width: 100%;
    border: none;
  }
}

/* ── Reduced motion ── */
@media (prefers-reduced-motion: reduce) {
  .live-player .live-player__back,
  .live-player .live-player__title-bar,
  .live-gate__back,
  .live-gate__cta {
    transition: none;
  }
}
</style>
